/** Ring geometry shared by the `active` token and the current-step and error markers. */ const MARKER_RING_GEOMETRY = "ring-2 ring-offset-2";
const MARKER_RING_CLASS = `${MARKER_RING_GEOMETRY} ring-info-solid`;
export const NODE_VISUAL_TOKENS = {
    default: {
        stroke: "#111827",
        fill: "#FFFFFF",
        borderClass: "border-foreground",
        bgClass: "bg-white",
        ringClass: "",
        markerRingClass: "",
        textClass: "text-foreground"
    },
    hover: {
        stroke: "#3B82F6",
        fill: "#EFF6FF",
        borderClass: "border-info-solid",
        bgClass: "bg-info-surface",
        ringClass: "",
        markerRingClass: "",
        textClass: "text-info"
    },
    active: {
        stroke: "#1D4ED8",
        fill: "#DBEAFE",
        borderClass: "border-info-strong",
        bgClass: "bg-info-surface",
        ringClass: `${MARKER_RING_CLASS} shadow-lg`,
        markerRingClass: "",
        textClass: "text-info"
    },
    currentStep: {
        stroke: "#3B82F6",
        fill: "#DBEAFE",
        borderClass: "border-info-solid",
        bgClass: "bg-info-surface",
        ringClass: "",
        markerRingClass: MARKER_RING_CLASS,
        textClass: "text-info"
    },
    onPath: {
        stroke: "#60A5FA",
        fill: "#EFF6FF",
        borderClass: "border-info-solid",
        bgClass: "bg-info-surface/50",
        ringClass: "",
        markerRingClass: "",
        textClass: "text-info"
    },
    error: {
        stroke: "#EF4444",
        fill: "#FEF2F2",
        borderClass: "border-danger-solid",
        bgClass: "bg-danger-surface",
        ringClass: "",
        markerRingClass: `${MARKER_RING_GEOMETRY} ring-destructive`,
        textClass: "text-danger"
    },
    orphan: {
        stroke: "#F59E0B",
        fill: "#FFFFFF",
        borderClass: "border-warning-solid",
        bgClass: "bg-white",
        ringClass: "",
        markerRingClass: "",
        textClass: "text-warning"
    },
    skeleton: {
        stroke: "#9CA3AF",
        fill: "#FFFFFF",
        borderClass: "border-line-strong",
        bgClass: "bg-white",
        ringClass: "",
        markerRingClass: "",
        textClass: "text-fg-subtle"
    }
};
// Priority: active > currentStep > onPath > hover > (edit ? error > orphan > skeleton) > default.
// Hover ranks above edit-only states so reaching toward a broken/incomplete
// step still gives the standard hover affordance. Dashing for skeleton/orphan
// is applied separately (see useNodeVisualState) so it survives hover.
export function resolveNodeVisualState({ isActive, isHovered, isCurrentStep = false, isOnPath = false, isEdit = false, hasPublishError = false, isOrphaned = false, isSkeleton = false }) {
    if (isActive) return "active";
    if (isCurrentStep) return "currentStep";
    if (isOnPath) return "onPath";
    if (isHovered) return "hover";
    if (isEdit) {
        if (hasPublishError) return "error";
        if (isOrphaned) return "orphan";
        if (isSkeleton) return "skeleton";
    }
    return "default";
}

//# sourceMappingURL=visualState.js.map